

export default [
  {
    path: '/consultar_admision',
    name: 'consultar_admision',
    component: () => import('@/views/admision/pages/ConsultarAdmision.vue'),
    meta: {
      hideBreadcrumb: true,
      pageTitle: 'Admision',
      breadcrumb: [
        {
          text: 'admision',
        },
        {
          text: 'Consultar Admision',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_consultar_admision', // Permiso requerido
      accion1: { url: '/crear_admision' },
    },
  },

  {
    path: '/crear_admision',
    name: 'crear_admision',
    component: () => import('@/views/admision/pages/CrearAdmision.vue'),

    pageTitle: 'Admision',
    meta: {
      pageTitle: 'Admision',
      breadcrumb: [
        {
          text: 'admision',
          to: '/consultar_admision' // <-- Add this line
        },
        {
          text: 'Crear admision',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_crear_admision',
      excel: false,
      pdf: false,
    },
  },


  {
    path: '/ver_admision/:token',
    name: 'ver_admision',
    component: () => import('@/views/admision/components/VerAdmision.vue'),
    meta: {
      hideBreadcrumb: true,
      pageTitle: 'Ver Admision',
      breadcrumb: [
        {
          text: 'admision',
          to: '/consultar_admision'
        },
        {
          text: 'Ver admision',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_ver_admision',
      excel: false,
      pdf: false,
    },
  },


  {
    path: '/editar_admision/:tokenPaciente',
    name: 'editar_admision',
    component: () => import('@/views/admision/pages/EditarAdmision.vue'),
    meta: {
      pageTitle: 'Editar Admision',
      breadcrumb: [
        {
          text: 'admision',
          to: '/consultar_admision'
        },
        {
          text: 'Editar admision',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_editar_admision',

      excel: false,
      pdf: false,
    },
  },
];